/**
 * Rellena los valores faltantes en un objeto usando valores por defecto de un objeto base.
 *
 * Esta función recorre todas las claves de `baseKey` y crea un nuevo objeto.
 * Para cada clave, utiliza el valor de `values` si existe; de lo contrario,
 * utiliza el valor correspondiente de `baseKey`.
 *
 * @param {Object} values - El objeto que contiene los valores reales. 
 *                          Algunas claves pueden estar ausentes o ser indefinidas.
 * @param {Object} baseKey - El objeto que contiene los valores por defecto para todas las claves.
 * @returns {Object} Un nuevo objeto con todas las claves de `baseKey`, usando los valores de `values`
 *                   cuando estén disponibles, o los valores por defecto de `baseKey` en caso contrario.
 *
 * @example
 * const defaults = { a: 1, b: 2 };
 * const values = { a: 10 };
 * const result = fillDefaults(values, defaults);
 * // result: { a: 10, b: 2 }
 */
export function fillDefaults(values,baseKey){
	return Object.fromEntries(
			Object.keys(baseKey).map((key) => [
				key,
				values[key] ?? baseKey[key],
			])
		)
}